import { useState } from "react";
import { ActionIcon, TextInput } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconCheck } from "@tabler/icons-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import clubRequest from "@/services/axios";

// A gallery photo's caption: the alt text Google reads on the salon site. Saved with the tick, Enter or
// on leaving the field, only when it changed.
export default function GalleryCaption({ id, caption }: { id?: number; caption?: string | null }) {
  const [value, setValue] = useState(caption ?? "");
  const client = useQueryClient();
  const save = useMutation({
    mutationFn: (text: string) => clubRequest.merchantGalleryCaptionUpdate({ id, caption: text }),
    onSuccess: () => {
      notifications.show({ message: "توضیح عکس ذخیره شد", color: "green", autoClose: 1500 });
      void client.invalidateQueries({ queryKey: ["gallery-images"] });
    },
  });
  const changed = value.trim() !== (caption ?? "").trim();
  const commit = () => { if (id && changed) save.mutate(value.trim()); };
  return (
    <TextInput
      size="sm"
      aria-label="توضیح عکس"
      placeholder="توضیح کوتاه این عکس، مثلاً نوع خدمت"
      maxLength={1000}
      value={value}
      onChange={(e) => setValue(e.currentTarget.value)}
      onBlur={commit}
      onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); commit(); } }}
      rightSection={changed ? <ActionIcon size="sm" color="violet" variant="light" loading={save.isLoading} onClick={commit} aria-label="ذخیره‌ی توضیح"><IconCheck size={14} /></ActionIcon> : undefined}
    />
  );
}
